<template>
  <b-row class="feature-banner banner-margin" v-if="bannersNum==1">
    <b-col cols="12">
      <router-link :to="route[0]">
        <img :src="bannerImgUrl[0]" alt />
      </router-link>
    </b-col>
  </b-row>
  <b-row class="banner-margin" v-else-if="bannersNum>1">
    <b-col
      class="text-center my-4"
      :cols="smallScrSizing"
      :sm="12/bannersNum"
      v-for="i in bannersNum"
      :key="i"
    >
      <router-link :to="route[i-1]">
        <img :src="bannerImgUrl[i-1]" alt />
        <h6 class="mt-1">{{title[i-1]}}</h6>
      </router-link>
    </b-col>
  </b-row>
</template>

<script>
export default {
  name: "FeatureBanner",
  computed: {
    smallScrSizing() {
      if (this.bannersNum == 3) return "6";
      else if (this.bannersNum == 4) return "6";
      else return "6";
    },
  },
  props: {
    bannerImgUrl: Array,
    route: Array,
    title: Array,
    bannersNum: Number,
  },
};
</script>

<style scoped>
.banner-margin {
  margin-top: 1rem;
  margin-bottom: 1.5rem;
  /* margin-right: 1.25rem;
  margin-left: 1.25rem; */
}

.feature-banner {
  /* max-height: 169px;
  min-height: 124; */
  overflow: hidden;
}

img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  object-position: center center;
  /* max-height: 100%; */
}
</style>